import dynamic from 'next/dynamic';

import ChatLoadingIndicator from '../Chat/ChatLoadingIndicator';

// Dynamic import pointing to the actual implementation file
const Markdown = dynamic(
  () => import('./Markdown').then((mod) => mod.default),
  {
    ssr: false,
    loading: () => (
      <ChatLoadingIndicator
        displayLoadingText={false}
        loadingText="Loading content..."
      />
    )
  }
);

export { Markdown };
export * from './Markdown.utils';
